import gsap from 'gsap';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(CustomEase);

export const ease = CustomEase.create('custom', 'M0,0 C0.25,0.25 0,1 1,1');
